import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AuthProvider } from './contexts/auth-context'
import { ConfirmProvider } from './context/confirm-context'
import './index.css'
// Import fonts separately so Vite resolves asset URLs relative to this file
import './fonts/erode.css'
import App from './App.tsx'
import * as Sentry from "@sentry/react"
// import { HEYO } from '@heyo.so/js'

Sentry.init({
  dsn: "https://be2771c8515231e90a0756935eb69a5e@o4509965848281088.ingest.us.sentry.io/4509965849329664",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracePropagationTargets: [],
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
})

// Initialize Heyo widget with default configuration
// The HeyoConfig component will dynamically adjust based on the current route
// HEYO.init({
//   projectId: '68ee60b756f6002db8663adc',
//   hidden: false,
// })

const queryClient = new QueryClient()

// Register the service worker so Web Push notifications can be received.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      // Non-fatal: app still works without push.
      console.warn('[push] Service worker registration failed', err)
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </AuthProvider>
      </Router>
      {typeof window !== 'undefined' && window.location.hostname.includes('localhost') && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>,
)
